// @/services/app/content/modules/se-analytics.js

/**
 * SeAnalyticsHandler
 *
 * Handles content retrieval for Supplier Engagement analytics tab,
 * filter overlay, and filter chips.
 */
export class SeAnalyticsHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get SE Analytics content by locale
   * @param {string} locale Locale to get content for (defaults to 'en')
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    const localeContent = this.store.state.data.seAnalytics?.[locale];
    if (localeContent) return localeContent;

    if (locale !== 'en') {
      return this.store.state.data.seAnalytics?.['en'] || null;
    }

    return null;
  }
}
